import { render, staticRenderFns } from "./RecursosOperacionaisParametrosPane.vue?vue&type=template&id=11bd1c3a&scoped=true&"
import script from "./RecursosOperacionaisParametrosPane.vue?vue&type=script&lang=js&"
export * from "./RecursosOperacionaisParametrosPane.vue?vue&type=script&lang=js&"
import style0 from "./RecursosOperacionaisParametrosPane.vue?vue&type=style&index=0&id=11bd1c3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bd1c3a",
  null
  
)

export default component.exports